import React from "react";
import Fade from "react-reveal/Fade";

import Countdown from "react-countdown-now";

import "./DragDropInteraction.css";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { Col, Row } from "reactstrap";

// toast
import "react-toastify/dist/ReactToastify.css";

// toast component
import { toast, ToastContainer } from "react-toastify";

import { createItemJson, currentLessonAttempt, currentLesson } from "../../common/services";

import { dateToString } from "../../common/utils";

interface Istate {
  completiontext: any;
  oncomplete: any;
  demomode: boolean;
  interactionid: any;
  introtext: any;
  lessonid: any;
  penalty: number;
  dragquestions: any;
  show: boolean;
  submittext: any;
  timelimit: number;
}

function randomId() {
  const reqlen = 5;
  let text = "tempdf_";
  const possible = "abcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < reqlen; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

// fake data generator
const getItems = (count) =>
  Array.from({ length: count }, (v, k) => k).map((k) => ({
    id: `item-${randomId()}`,
    content: `item ${k}`,
  }));

const getItems2 = (count) =>
  Array.from({ length: count }, (v, k) => k).map((k) => ({
    id: `item-${randomId()}`,
    content: `item ${k}`,
    answer: "",
  }));

class DragDropInteraction extends React.Component<Istate> {
  public state = {
    answer: true,
    backupitems: [] as any[],
    backupitems2: [] as any[],
    completed: false,
    completiontext: this.props.completiontext,
    demomode: this.props.demomode,
    introtext: this.props.introtext,
    items: [] as any[],
    items2: [] as any[],
    penalty: this.props.penalty,
    quiz: false,
    quizlaunchtime: Date.now() + 5000,
    tries: 1,
    dragquestions: this.props.dragquestions,
    score: 0,
    show: false,
    showTimer: false,
    timelimit: this.props.timelimit * 1000,
  };

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.process = this.process.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);

    const tempdrag = [] as any[];

    const tempdrop = [] as any[];

    for (const dragdrop of this.state.dragquestions) {
      tempdrag.push({
        id: randomId(),
        content: dragdrop.question,
        answer: dragdrop.answer,
        completion: dragdrop.completion_text,
      });
      tempdrop.push({ id: randomId(), content: dragdrop.answer, answer: "" });
    }

    // randomize order of answers
    tempdrop.sort(() => Math.random() - 0.5);

    this.state.items = tempdrag;
    this.state.items2 = tempdrop;
    // in case of error
    this.state.backupitems = tempdrag;
    this.state.backupitems2 = tempdrop;
  }

  public handleClick() {
    this.setState({ show: !this.state.show });
  }

  public onDragEnd(result) {
    console.log("dest: " + Object.keys(result));

    if(result.destination === null) {
      console.log("destination is null");
      return
    }

    console.log("destdropp: " + result.destination.droppableId);

    const newtries = this.state.tries + 1;

    this.setState({ tries: newtries });

    for (const drop of this.state.items2) {
      console.log(drop);
      if (drop.id === result.destination.droppableId) {
        const index = this.state.items2.findIndex(
          (element) => element.id === drop.id
        );
        console.log("match found: " + index);
        if (this.state.items[result.source.index].answer === drop.content) {
          drop.answer = this.state.items[result.source.index].content;
          this.state.items2[index] = drop;
          // toast(this.state.items[result.source.index].completion); // toast feedback

          const items = this.state.items;

          items.splice(result.source.index, 1);

          this.setState({ items });

          if (this.state.items.length < 1) {
            // this.setState({completed: true})
            // toast(this.state.completiontext);
            this.process();
          }
        }
      }
    }

    console.log(
      "source index:" +
        result.source.index +
        ", dest index: " +
        result.destination.index
    );
  }

  public process() {
    const timeTaken = (Date.now() - this.state.quizlaunchtime) / 1000.0;

    const item = {
      time_start: dateToString(this.state.quizlaunchtime),
      time_end: dateToString(Date.now()),
      tries_count: this.state.tries,
      lesson: this.props.lessonid,
      interaction: this.props.interactionid,
      answer: [],
    };
 
    if (!this.state.demomode) {

      const currentlesson = currentLesson();

      createItemJson(
        "interaction_attempts/?attemptid=" + currentlesson.sessionKey,
        item,
        (text) => this.handleGenCreatedItemLoaded(text)
      );
    } else {
      // toast.info(this.props.completiontext);
      const score = (this.state.dragquestions.length / this.state.tries) * 100;
      setTimeout(this.props.oncomplete(score), 1500);
    }
    console.log(item);
  }

  public handleGenCreatedItemLoaded(res) {
    console.log(res);
    if (res.code === 200 || res.code === 201) {
      this.setState({ completed: true });

      // toast.info(this.props.completiontext);

      setTimeout(this.props.oncomplete(), 1500);
    } else {
      toast.error("Please try again");
      const items = this.state.backupitems;
      const items2 = this.state.backupitems2;
      const tries = 1;

      const quizlaunchtime = Date.now() + 5000;
      const quiz = false;
      const showTimer = false;

      this.setState({ items, items2, tries, quizlaunchtime, quiz, showTimer });

      this.forceUpdate();
    }
  }

  public render() {
    const grid = 8;

    const getItemStyle = (isDragging, draggableStyle) => ({
      // some basic styles to make the items look a bit nicer
      userSelect: "none",
      padding: `${grid * 2}px`,
      margin: `0 0 ${grid}px 0`,
      fontFamily: "Roboto",
      fontSize: "18px",
      borderRadius: "15px",
      // change background colour if dragging
      background: isDragging ? "#5a5a5a70" : "var(--grey-dark)",
      borderColor: isDragging ? "var(--blue)" : "var(--green)",
      border: isDragging ? "2px solid var(--blue)" : "",
      // styles we need to apply on draggables
      ...draggableStyle,
    });

    const getDrppedItemStyle = (isAnswered) => ({
      // some basic styles to make the items look a bit nicer
      userSelect: "none",
      padding: `${grid * 2}px`,
      margin: `0 0 ${grid}px 0`,
      fontFamily: "Roboto",
      fontSize: "18px",
      borderRadius: "15px",
      // change background colour if dragging
      background: isAnswered ? "var(--grey-light)" : "var(--grey-dark)",
      color: isAnswered ? "#000" : "#fff",
      border: isAnswered ? "1px solid var(--green)" : ".5px solid var(--red)",
      borderLeftWidth: "0",
      borderRightWidth: "0",
      borderTopWidth: "0",
      textAlign: "center",
    });

    const getListStyle = (isDraggingOver) => ({
      // background: isDraggingOver ? "#1a1a1a" : "#1a1a1a",
      borderRadius: "2px",
      padding: `${grid}`,
      width: "100%",
      fontFamily: "Roboto",
      fontSize: "20px",
      fontWeight: "bold",
    });

    return (
      <div style={{ color: "#000", width: "100%" }}>
        <ToastContainer style={{ zIndex: 9999999 }} />
        <div className="dnd-content">
          <div className="dnd-exercise-details">
            <Fade when={this.state.quiz && !this.state.completed}>
              <p className="recall-intro-text">{this.props.introtext}</p>
            </Fade>
            <Fade when={this.state.quiz && !this.state.completed}>
              <DragDropContext onDragEnd={this.onDragEnd}>
                <Row style={{ width: "100%" }}>
                  <Col className="questions-col" xs="12" sm="12" lg="6">
                    <Droppable droppableId="droppable">
                      {(providedd, snapshotd) => (
                        <div
                          {...providedd.droppableProps}
                          ref={providedd.innerRef}
                          style={getListStyle(snapshotd.isDraggingOver)}
                        >
                          {this.state.items.map((item, index) => (
                            <Draggable
                              key={item.id}
                              draggableId={item.id}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <div
                                  className="dnd-question"
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={getItemStyle(
                                    snapshot.isDragging,
                                    provided.draggableProps.style
                                  )}
                                >
                                  {item.content}
                                  {console.error(item.content)}
                                </div>
                              )}
                            </Draggable>
                          ))}
                        </div>
                      )}
                    </Droppable>
                  </Col>

                  <Col className="answers-col" xs="12" sm="16" lg="6">
                    {this.state.items2.map((item, index) => (
                      <Droppable
                        key={item.id}
                        droppableId={item.id}
                        isCombineEnabled={false}
                      >
                        {(providedd, snapshotd) => (
                          <div
                            {...providedd.droppableProps}
                            ref={providedd.innerRef}
                            style={getDrppedItemStyle(item.answer.length > 0)}
                          >
                            <p style={{ fontWeight: "bold", marginBottom: '0px' }}>{item.answer}</p>
                            <p style={{ fontWeight: "normal", marginBottom: '0px' }}>
                              {item.content}
                            </p>
                          </div>
                        )}
                      </Droppable>
                    ))}
                  </Col>
                </Row>
              </DragDropContext>
            </Fade>

            <Fade when={this.state.completed}>
              <div>
                <p className="exercise-complete">{this.state.completiontext}</p>
              </div>
            </Fade>
          </div>
          <div
            className="dnd-duration-details"
            style={{ display: !this.state.show ? "flex" : "none" }}
          >
            <Fade when={this.state.show === false}>
              {/* <div className="fade-reveal"> */}
              <p className="right">
                Your quiz begins in:
                <Countdown
                  date={this.state.quizlaunchtime}
                  // tslint:disable-next-line jsx-no-lambda
                  onComplete={() => {
                    this.setState({ show: true, quiz: true, showTimer: true });
                  }}
                />
              </p>
              {/* </div> */}
            </Fade>
          </div>
        </div>
      </div>
    );
  }
}
export default DragDropInteraction;



// WEBPACK FOOTER //
// ./src/components/DnDInteraction/DragDropInteraction.Component.tsx